import { useDailyEvent } from '@daily-co/daily-react';
import { useRef } from 'react';

const NEW_MESSAGE_SOUND_SRC = '/audio/mixkit-happy-bell-alert-601.wav';

/**
 * ChatNotificationSound component plays a chime sound when a chat message is received.
 * This component listens for app-message events from Daily.co and plays the notification sound.
 *
 * Note: This component must be rendered inside a DailyProvider to access Daily hooks.
 */
export const ChatNotificationSound: React.FC = () => {
  const audioRef = useRef<HTMLAudioElement>(null);

  // Listen for app-message events from Daily.co chat
  useDailyEvent('app-message', (event) => {
    // Only play sound for chat messages
    if (event?.data?.event === 'chat-msg') {
      audioRef.current?.play();
    }
  });

  return (
    <audio
      id="chat-notification-audio"
      src={NEW_MESSAGE_SOUND_SRC}
      ref={audioRef}
    />
  );
};
